module.exports = __webpack_public_path__ + "components/flag/static/square/ke-1be8efb03d0c07cc8e07ee67d9e8bfec.svg";